import { useState } from 'react'

const STORAGE_KEY = 'showAdvancedFilterOptions'

function useAdvancedFilterOptions() {
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  )

  const toggleAdvancedOptions = () => {
    const nextValue = !showAdvancedOptions
    localStorage.setItem(STORAGE_KEY, String(nextValue))
    setShowAdvancedOptions(nextValue)
  }

  return [showAdvancedOptions, toggleAdvancedOptions]
}

export default useAdvancedFilterOptions
